import { InfoIcon } from 'components/icons/Info'
import type { BreakoutTooltipProps } from './BreakoutTooltip'
import { BreakoutTooltip } from './BreakoutTooltip'
import classNames from 'classnames'

/**
 * Renders a InfoIcon component wrapped in a tooltip component
 */
export function BreakoutInfoTooltip({
  iconSize = 14,
  kind = 'default',
  iconClassName,
  label,
  srOnlyContent = true,
  ...rest
}: Omit<BreakoutTooltipProps, 'children'> & {
  iconSize?: number
  kind?: 'default' | 'accent'
  label?: React.ReactNode
  iconClassName?: string
  /**
   * Also render string content as screen-reader-only text. Turn off where
   * the tooltip restates text that is already visible nearby.
   */
  srOnlyContent?: boolean
}) {
  return (
    <BreakoutTooltip {...rest}>
      <div
        className={classNames(
          'inline-flex items-center gap-1',
          rest.enabled === false ? 'cursor-not-allowed' : 'cursor-pointer'
        )}
      >
        {label}
        {/* The trigger can't take focus and the tooltip is only in the DOM
            while hovered, so screen readers get the text from here. */}
        {srOnlyContent && typeof rest.content === 'string' && (
          <span className="sr-only">{rest.content}</span>
        )}
        <span>
          <InfoIcon
            size={iconSize}
            className={classNames(
              kind === 'accent' && 'text-fixed-accent-color',
              iconClassName
            )}
          />
        </span>
      </div>
    </BreakoutTooltip>
  )
}
